import { Component, effect, inject, Input } from '@angular/core';
import { LoginStateService, UserDataStateService } from '@ribera-web/auth-data-acess';
import { JwtUtil, NotificationStore } from '@ribera-web/token-decodifier-service';
import { NotificationAlertUi } from "@ribera-web/notification-alert-ui";
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { RiberaDefaultBtn } from '@ribera-web/ribera-default-btn';
import { APP_CONFIG } from '@ribera-web/app-token';
import { PopoverModule } from "primeng/popover";
import { Location } from '@angular/common';

@Component({
  selector: 'lib-header',
  standalone: true,
  imports: [CommonModule, RouterModule, RiberaDefaultBtn, PopoverModule, NotificationAlertUi],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {

  @Input() isCollapsed = false;
  private config = inject(APP_CONFIG);

  currentDate = new Date();
  menuVisible = false;
  bookingsSubmenuOpen = false;
  servicesSubmenuOpen = false;
  activeDropdown: 'alojamiento' | 'servicios' | null = null;
  private loginState = inject(LoginStateService);
  private router = inject(Router);
  private jwtUtil = inject(JwtUtil);
  private notificationStore = inject(NotificationStore);
  // Temporal hasta conectar con perfil real
  private userDataSateService = inject(UserDataStateService);
  private location = inject(Location);
  userDataResponse = this.userDataSateService.userDataResponse;
  loggedUserName = '';
  avatarUrl = '/member/dashboard/user-image-default.png';
  notification = false;

  private readonly DEFAULT_TOKEN =
    'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';

  constructor() {
    effect(() => {
      const responseUserData = this.userDataResponse();
      if (responseUserData?.data) {
        this.loggedUserName = `${responseUserData.data.firstName} ${responseUserData.data.lastName}`;
      }
    });

    // Inicializa nombre y avatar desde el token si existe y NO es el token por defecto
    const token = localStorage.getItem('accessToken');
    if (token && token !== this.DEFAULT_TOKEN) {
      try {
        const userData = this.jwtUtil.getUserFromToken(token);
        this.loggedUserName = userData.fullName || userData.name || '';
        this.avatarUrl = userData.picture || userData.avatar || this.avatarUrl;
        
        const notiView = this.notificationStore.get();
        this.notification = notiView.view ?? false;
      } catch {
        // Ignorar errores de parseo y mantener valores por defecto
      }
    }
  }

  goToLoginAsPromoter() {
    // this.userTypeService.setType('promotor');
    this.router.navigate(['/auth/login']);
  }

  goToLoginAsUser() {
    // this.userTypeService.setType('usuario');
    this.router.navigate(['/auth/login']);
  }

  goToLoginAsInclub() {
    this.router.navigate(['/auth/login/inclub']);
  }

  // Función para alternar (abrir/cerrar)
  toggleMenu() {
    this.menuVisible = !this.menuVisible;
  }

  closeMenu() {
    this.menuVisible = false;
  }

  toggleBookingSubmenu(event: Event) {
    event.stopPropagation();
    this.bookingsSubmenuOpen = !this.bookingsSubmenuOpen;
  }

  toggleServiceSubmenu(event: Event) {
    event.stopPropagation();
    this.servicesSubmenuOpen = !this.servicesSubmenuOpen;
  }
  
  markAsViewed() {
    this.notificationStore.patch((current) => {
      if (!current) return current;
      return { ...current, view: true };
    });
  }

  setFilterRooms() {
    localStorage.setItem('filterByRooms', 'true');
    this.closeMenu();
  }

  // Helpers para saber qué icono mostrar
  get menuIcon(): string {
    return this.menuVisible
      ? '/header/png/close-icon.png'
      : '/header/png/Burger_menu.svg';
  }

  get isLoggedIn(): boolean {
    // Verifica si hay un token válido (no el token por defecto)
    const token = localStorage.getItem('accessToken');
    return !!token && token !== this.DEFAULT_TOKEN;
  }

  get isMemberEventsRoute(): boolean {
    const currentPath = this.router.url.split('?')[0];
    return currentPath === '/events' || currentPath.startsWith('/events/');
  }

  get memberEventsBreadcrumb(): string {
    const segments = this.router.url.split('?')[0].split('/').filter(Boolean);
    if (segments.includes('personalizar')) return 'Personaliza tu evento';
    if (segments.length > 1 && segments[1] !== 'disponibles') {
      return 'Detalle del evento';
    }
    return 'Disponibles';
  }

  get isPromotionsRoute(): boolean {
    const currentPath = this.router.url.split('?')[0];
    return (
      currentPath === '/promotions' ||
      currentPath.startsWith('/promotions/')
    );
  }

  get promotionsBreadcrumb(): string {
    const segments = this.router.url.split('?')[0].split('/').filter(Boolean);

    if (segments.includes('booking')) {
      return 'Disponibilidad';
    }

    if (segments.includes('detail')) {
      return 'Detalle de promoción';
    }

    return 'Disponibles';
  }

  logout() {
    this.loginState.logout();
    this.closeMenu();
    this.router.navigate(['/']);
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  navigateToHome() {
    if (this.isLoggedIn) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/']);
    }
  }

  openDropdown(dropdown: 'alojamiento' | 'servicios') {
    this.activeDropdown = dropdown;
  }

  closeDropdown(dropdown: 'alojamiento' | 'servicios') {
    if (this.activeDropdown === dropdown) {
      this.activeDropdown = null;
    }
  }

  navigateToBookings() {
    this.router.navigate(['/bookings']);
  }

  navigateToRiberaPromoters() {
    window.location.href = this.config.URL_RIBERA_PROMOTERS;
  }

  back() {
    this.location.back();
  }
}
